<template>
  <div>
    <div class="img-point-container">
      <a class="nav-link left" :href="prev_key"><font-awesome-icon :icon="['fas', 'angle-double-left']" /></a>
      <img width="1140" height="600" class="img-point" :src="image_url" :alt="image_keys"/>
      <a class="nav-link right" :href="next_key"><font-awesome-icon :icon="['fas', 'angle-double-right']" /></a>
    </div>
    <p><strong>Country:</strong> {{country}}</p>
    <p v-if="city"><strong>City:</strong> {{city}}</p>
    <p v-if="region"><strong>Region:</strong> {{region}}</p>
    <p><strong>Coordinates:</strong> <a target="_blank" :href="map_link">{{coordinates}}</a></p>
    <p v-html="description"><strong>Description:</strong> {{description}}</p>
  </div>
</template>
<style>
.img-point {
  width:100%;
  height:auto;
}
.nav-link {
  top: 40%;
  display: block;
  font-size: 2.5em;
  vertical-align: middle;
  position: absolute;
  background-color: white;
  padding: 2px;
  opacity: 0.7;
  margin: 0;
}

.left {
  left: 5px;
}
.right {
  right: 5px;
}
.img-point-container {
  position: relative;
}
</style>
<script>
export default {
  props: {
    prev_key: { required: true, type: String },
    next_key: { required: true, type: String },
    description: { required: true, type: String },
    coordinates: { required: true, type: String },
    map_link: { required: true, type: String },
    city: { required: false, type: String },
    region: { required: false, type: String },
    country: { required: true, type: String },
    image_url: { required: true, type: String },
    image_keys: { required: true, type: String }
  },
  name: 'GalleryPoint'
}
</script>



// WEBPACK FOOTER //
// src/components/GalleryPoint.vue